import {connect} from '../../app/connect';
import IssuesPanelHeader from './IssuesPanelHeader';
import {getCurrentIssuesCount, isFetchReportLoading, isFilteredByCustomAttributes} from '../../app/selectors';
import {createBcfFileAction, getModelTypeAndUnit, fetchIssuesReport} from '../../app/actions';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';

const mapStateToProps = state => ({
  issuesCount: getCurrentIssuesCount(state),
  isFetchReportLoading: isFetchReportLoading(state),
  addXlsxPdfExportOptions: isFilteredByCustomAttributes(state)
    ? featureFlags.get(FEATURE_FLAGS.DOC_VIEW_PDF_AND_XLSX_EXPORT) &&
      featureFlags.get(FEATURE_FLAGS.EXPORT_WITH_CUSTOM_ATTRIBUTES_FILTERS)
    : featureFlags.get(FEATURE_FLAGS.DOC_VIEW_PDF_AND_XLSX_EXPORT)
});

const mapDispatchToProps = {
  fetchIssuesReport,
  createBcfFileAction,
  getModelTypeAndUnit
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssuesPanelHeader);
